export const APP_SITE_ID=4;
export const APP_NO_IMG='/images/pic--goods-0.jpg';
export const WIDTH = 1023.98